import httpClient from "@api/http";
import { BannerEntity } from "@entity/banner.entity";
import { NoticePostOption, UpdateBannerOrderAndTitle } from "@interface/banner";

class BannerRepository {
  async getBanner(): Promise<BannerEntity[]> {
    const response = await httpClient.get("/banner/admin");
    return response.data;
  }

  async updateOrderAndBanner({
    id,
    order,
    title,
    noticePostId,
  }: UpdateBannerOrderAndTitle): Promise<BannerEntity> {
    const response = await httpClient.patch(`/banner/${id}`, {
      order,
      title,
      noticePostId,
    });
    return response.data;
  }

  /** 배너에 연결할 공지사항 게시글 목록 */
  async getNoticePosts(): Promise<NoticePostOption[]> {
    const response = await httpClient.get("/banner/notice-posts");
    return response.data;
  }

  async deleteBannerById(id: string) {
    await httpClient.delete(`/banner/${id}`);
  }

  async createOneByOrderAndTitle(order: number, title: string) {
    const response = await httpClient.post("/banner", { order, title });
    return response.data;
  }

  async getPresignedUrl(id: string) {
    const response = await httpClient.get(`/banner/${id}/presigned-url`);
    return response.data;
  }

  async updateBannerImage(id: string, key: string) {
    const response = await httpClient.patch(`/banner/${id}/image`, { key });
    return response.data;
  }

  async deleteBannerImage(id: string) {
    await httpClient.delete(`/banner/${id}/image`);
  }
}

export default new BannerRepository();
